import { z } from 'zod';

import { mobilePhoneSchema } from 'features/onboarding/schemas/primitives';

/**
 * First wizard step: the minimum needed to open a lead and send an OTP —
 * the trade name, the contact person, a mobile number, and the store
 * location on the map. The address itself is never typed; it is resolved
 * from the captured coordinates through the Google proxy.
 */
export const stepContactSchema = z
  .object({
    commercialName: z.string().min(1, 'required'),
    ownerName: z.string().min(1, 'required'),
    phoneNumber: mobilePhoneSchema,
    latitude: z.number().nullable().optional(),
    longitude: z.number().nullable().optional(),
  })
  .superRefine((v, ctx) => {
    if (typeof v.latitude !== 'number' || typeof v.longitude !== 'number') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'locationRequired',
        path: ['latitude'],
      });
    }
  });

export type StepContactInput = z.infer<typeof stepContactSchema>;
